export { default } from './StuiTruncatedContent'
